import { handleTrackClick } from "~/lib/analytics/handleTrackClick";
import styles from "./SalesBanner.module.css";

/**
 * @param {Object} props
 * @param {import('./use-cta').CallToAction} [props.cta]
 */
export default function SalesBanner({ positionPrefix, cta }) {
  if (!cta) {
    return null;
  }

  function handleClick(e) {
    handleTrackClick(`${positionPrefix}-${cta.id}`, e);
    // cta.onClick?.(e);
  }

  const Tag = cta.href ? "a" : "button";
  return (
    <Tag className={styles.bannerCta} onClick={handleClick} href={cta.href}>
      {cta.text}
    </Tag>
  );
}
